import { DateRange, Delete, KeyboardArrowLeft, KeyboardArrowRight } from "@mui/icons-material";
import { Button, ButtonGroup, Card, CardActions, CardContent, Container, Divider, Grid, IconButton, InputAdornment, List, ListItem, ListItemSecondaryAction, ListItemText, Slider, Stack, TextField, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import $carbon, { pesticideTypes } from "../../../services/$carbon";
import SelectInput from "../../ui/SelectInput";
import { LocalizationProvider, MobileDatePicker } from "@mui/x-date-pickers";
import moment from "moment";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { variables } from "../../../styles/abstract/variables";

function PesticidesForm(props) {
  const { model, setModel, nextStep, prevStep, products, year, area } = props;

  const [local, setLocal] = useState({
    date: undefined,
    category: undefined,
    type: undefined,
    amountP: undefined,
    energy: undefined,
  });

  const createProductCategories = () => {
    return [...new Set(products.map(p => p.function))].map(p => ({ value: p, label: pesticideTypes[p] }));
  }

  const createProductTypes = (category) => {
    return products.filter(p => p.function === category).map(p => ({ value: p.active_substance, label: p.active_substance }));
  }

  console.log(products)

  useEffect(() => {
    if (model.records.length > 0) {
      let total = $carbon.calculatePesticideEmission(model.records, area);
      console.log(total);
      setModel({ totalEmission: total });
    } else {
      setModel({ totalEmission: undefined });
    }
  }, [JSON.stringify(model.records)]);


  const renderRecords = () => {
    if (model.records.length === 0) {
      return (
        <Grid item xs={12}>
          <Typography>No records</Typography>
        </Grid>
      )
    }

    return (
      <Grid item xs={12}>
        <List dense>
          {
            model.records.map((record, i) => (
              <ListItem className="co-background" key={i}>
                <ListItemText primary={record.category + ' | ' + record.type} secondary={`Amount (kg/ha): ${record.amountP} | ${record.date}`} />
                <ListItemSecondaryAction><IconButton onClick={() => setModel({ records: model.records.filter((r, j) => j !== i) })} size="small" color="error"><Delete fontSize="small" /></IconButton></ListItemSecondaryAction>
              </ListItem>
            ))
          }
        </List>
      </Grid>
    )

  }

  const renderContent = () => {
    return (
      <Grid item xs={12}>
        <Card elevation={5} style={{ borderRadius: 0, background: 'transparent' }}>
          <CardContent className="co-background" sx={{ padding: '40px' }}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <LocalizationProvider dateAdapter={AdapterMoment}>
                  <MobileDatePicker
                    format="YYYY-MM-DD"
                    minDate={moment(`${year}-01-01`)}
                    maxDate={moment(`${year}-12-31`)}
                    slotProps={{
                      textField: {
                        label: 'Date',
                        variant: 'outlined',
                        fullWidth: true,
                        size: 'small',
                        InputProps: { endAdornment: <InputAdornment position="end" sx={{ cursor: 'pointer', mb: '3px' }}><DateRange fontSize="small" /></InputAdornment> }
                      }
                    }}
                    value={local.date ? moment(local.date) : undefined}
                    onChange={(newValue) => setLocal(current => ({ ...current,  date: newValue.format('YYYY-MM-DD') }))} />
                </LocalizationProvider>
              </Grid>
              <Grid item xs={12} sm={6}>
                <SelectInput name="Category" value={local.category} items={createProductCategories()} onChange={(e) => { setLocal(current => ({...current, category: e.target.value, type: undefined, energy: undefined })) }} label="Category" variant="outlined" fullWidth size="small" />
              </Grid>
              <Grid item xs={12} sm={6}>
                <SelectInput name="Active Ingredient" value={local.type} items={createProductTypes(local.category)} onChange={(e) => { setLocal(current => ({...current, type: e.target.value, energy: products.find(p => p.active_substance === e.target.value).energy_used })) }} label="Category" variant="outlined" fullWidth size="small" />
              </Grid>
              <Grid item xs={12} sm={8}>
                <TextField size="small" value={local.amountP} onChange={(e) => setLocal(current => ({...current, amountP: e.target.value }))} type="number" label="Amount of active ingredient (kg/ha)" variant="outlined" fullWidth />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Button disabled={!local.category || !local.date || (local.amountP === 0 && local.energy === 0 && local.type === 0)} onClick={() => setModel({ records: [...model.records, { ...local }] })} variant="contained" >Add record</Button>
              </Grid>
              <Grid item xs={12}>
                <Divider color="primary" light style={{ background: variables.primary, height: '3px' }} />
              </Grid>
              {renderRecords()}
            </Grid>
          </CardContent>
          <CardActions style={{ padding: '0 16px 16px 16px', justifyContent: 'flex-end' }} className="co-background">
            <Button onClick={prevStep} variant="contained" endIcon={<KeyboardArrowLeft />}>Previous</Button>
            <Button onClick={nextStep} variant="contained" endIcon={<KeyboardArrowRight />}>Next</Button>
          </CardActions>
        </Card>
      </Grid>
    )
  }

  return (
    <Container>
      <Grid container spacing={2}>
        {renderContent()}
      </Grid>
    </Container>
  );
}

export default PesticidesForm;